import { render, staticRenderFns } from "./PostEditor.vue?vue&type=template&id=6ef9546d&scoped=true&"
import script from "./PostEditor.vue?vue&type=script&lang=js&"
export * from "./PostEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef9546d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ef9546d')) {
      api.createRecord('6ef9546d', component.options)
    } else {
      api.reload('6ef9546d', component.options)
    }
    module.hot.accept("./PostEditor.vue?vue&type=template&id=6ef9546d&scoped=true&", function () {
      api.rerender('6ef9546d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/post/PostEditor.vue"
export default component.exports